import { ComponentRef, Directive, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import type { PopoverPlacement } from '@frontendlib/components/features/popover/types/placement';
import type { PopoverTrigger } from '@frontendlib/components/features/popover/types/trigger';
import { startWith, takeUntil } from 'rxjs/operators';
import { SheetsListContextMenuComponent } from '../components/sheets-list-context-menu/sheets-list-context-menu.component';
import { SheetsListStateService } from '../services/sheets-list-state.service';

@Directive({
  selector: '[appSheetsListContextMenu]',
  standalone: false,
})
export class SheetsListContextMenuDirective extends ContextMenuDirective implements OnInit, OnDestroy {
  @Input()
  public appSheetsListContextMenuWithAdvancedSearch: boolean;
  @Input()
  public appSheetsListContextMenuWithScore: boolean;
  /** SBUX-1043: the fourth panel's own "Import spreadsheet" at the foot of this menu. */
  @Input()
  public appSheetsListContextMenuWithImport = false;
  @Output()
  public readonly appSheetsListContextMenuImport = new EventEmitter<void>();
  @Input()
  public stchPopoverTrigger: PopoverTrigger = 'click';
  @Input()
  public stchPopoverPlacement: PopoverPlacement = 'bottomLeft';

  private readonly sheetsListStateService = inject(SheetsListStateService);

  public registerInstance(componentRef: ComponentRef<SheetsListContextMenuComponent>) {
    componentRef.instance.state = this.sheetsListStateService.state;
    componentRef.instance.withAdvancedSearch = this.appSheetsListContextMenuWithAdvancedSearch;
    componentRef.instance.withScore = this.appSheetsListContextMenuWithScore;
    componentRef.instance.withImport = this.appSheetsListContextMenuWithImport;
    componentRef.instance.importChosen
      .pipe(takeUntil(this.alive))
      .subscribe(() => this.appSheetsListContextMenuImport.emit());
  }

  public registerComponent() {
    return SheetsListContextMenuComponent;
  }

  public override ngOnInit() {
    super.ngOnInit();

    this.sheetsListStateService.state
      .changes()
      .pipe(startWith(null), takeUntil(this.alive))
      .subscribe(() => {
        this.isDefaultStateObservable?.next(this.sheetsListStateService.state.isDefault());
      });

    if (!this.isDefaultStateObservable) {
      return;
    }

    this.isDefaultStateObservable.pipe(takeUntil(this.alive)).subscribe((isDefault) => {
      if (isDefault && !this.sheetsListStateService.state.isDefault()) {
        this.sheetsListStateService.state.resetToDefault();
      }
    });
  }
}
